/**
 * Zod schema for the `sessionNotes` collection. Private freeform notes
 * tied to a session — owner-read/write only at the rules layer.
 */

import { z } from 'zod';

export const sessionNoteDocumentSchema = z.object({
  eventId: z.string(),
  userId: z.string(),
  sessionId: z.string(),
  content: z.string(),
});
